/* eslint-disable prettier/prettier */
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchTransactionDetailsSwipeAPI } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const fetchTxnDetailsSwipe = createAsyncThunk('get/txnDetailsSwipe', FetchTransactionDetailsSwipeAPI);

export const FetchSwipeTxnDetailsSlice = createSlice({
	name: 'fetchTxnDetailsSwipe',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[fetchTxnDetailsSwipe.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[fetchTxnDetailsSwipe.rejected.toString()]: setAPIError,
		[fetchTxnDetailsSwipe.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[FetchSwipeTxnDetailsSlice.name]: ReturnType<typeof FetchSwipeTxnDetailsSlice.reducer>;
}

export const fetchTxnDetailsSelector = (state: IStates): any => {
	return state[FetchSwipeTxnDetailsSlice.name] || {};
};

export const useSwipeTxnDetails = (): any => useSelector(fetchTxnDetailsSelector);

export const getSwipeTxnDetails =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(fetchTxnDetailsSwipe(params));
		return;
	};

export const resetSwipeTxnDetails =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(FetchSwipeTxnDetailsSlice.actions.RESET());
		return;
	};
